import React, { useState } from "react";
import "./VoteResults.css";
import tickIcon from "../../../../icons/tickIcon.png";

const VoteResults = ({
  users,
  localPlayer,
  voteCountData,
  chameleonIndex,
  roundStarted,
  updateRoundStarted,
  chameleonGuess,
  setChameleonGuess,
  showResults,
  setShowResults,
  secretWord,
  guessedWord,
  currentScores,
  roundScore,
  currentVotingData,
}) => {
  const highestVoteCount = Math.max.apply(null, Object.values(voteCountData)),
    votedPlayerName = Object.keys(voteCountData).filter(function (x) {
      return voteCountData[x] === highestVoteCount;
    });
  const [msg2Display, updateMsg] = useState(
    `${votedPlayerName[0]} was voted as the Chameleon...`
  );

  if (showResults === false) {
    //overallTimer
    if (
      users[chameleonIndex]?.name !== votedPlayerName[0] ||
      votedPlayerName.length !== 1
    ) {
      setTimeout(function () {
        setShowResults(true);
      }, 4000);
    }

    // messageTimer
    let messageTimer = setTimeout(function () {
      updateMsg(`...the Chameleon was ${users[chameleonIndex]?.name}`);
      clearTimeout(messageTimer);
      if (
        users[chameleonIndex]?.name === votedPlayerName[0] &&
        votedPlayerName.length === 1
      ) {
        prepareChamleonGuess();
      }
    }, 3000);
  }

  const prepareChamleonGuess = () => {
    // guessTimer
    let guessTimer = setTimeout(function () {
      setChameleonGuess(true);
      clearTimeout(guessTimer);
    }, 3000);
  };

  if (showResults) {
    return (
      <div className="playerVotingList">
        <div className="voteTitleContainer">
          {users[0].name === localPlayer.name ? (
            <div
              className="startNewRoundButton"
              onClick={() => updateRoundStarted(roundStarted)}
            >
              Start new round
              <img className="tickIcon" src={tickIcon} alt="start new round" />
            </div>
          ) : (
            <p className="voteTitleText">
              Waiting for {users[0].name} (host) to start a new round
            </p>
          )}
        </div>

        <div className="roundSummaryContainer">
          <div className="playerVotingContainer">
            <p div className="playerVoteTitle">
              Round Summary
            </p>
          </div>
          <div className="roundSummaryText">
            <p className="roundSummaryCatagory">Chameleon: </p>
            <p className="roundSummaryResult">{users[chameleonIndex]?.name}</p>
          </div>

          <div className="roundSummaryText">
            <p className="roundSummaryCatagory">Secret Word: </p>
            <p className="roundSummaryResult">{secretWord}</p>
          </div>

          {guessedWord !== null ? (
            <div className="roundSummaryText">
              <p className="roundSummaryCatagory">Guessed Word: </p>
              <p className="roundSummaryResult">{guessedWord}</p>
            </div>
          ) : null}
        </div>

        <div className="roundSummaryContainer">
          <div className="playerVotingContainer">
            <div className="playerVoteTitle">Scores</div>
          </div>

          {users.map((user) => (
            <div key={user.name} className="playerVotingContainer">
              <div className="playerNameVoting">
                {users[chameleonIndex].name === user.name ? (
                  <p
                    className="playerNameText"
                    style={
                      user.name === localPlayer.name
                        ? { color: "yellow" }
                        : { color: "" }
                    }
                  >
                    {user.name}
                  </p>
                ) : (
                  <p
                    className="playerNameText"
                    style={
                      user.name === localPlayer?.name
                        ? { color: "yellow" }
                        : { color: "" }
                    }
                  >
                    {user.name}
                  </p>
                )}
              </div>
              <div className="playerVoteNum">
                {currentScores[user.name]} (+{roundScore[user.name]})
              </div>
            </div>
          ))}
        </div>

        <div className="voteTableContainer">
          <div className="playerVotingContainer">
            <div className="playerVoteTitle">Player Votes</div>
            <div className="playerVoteTitle">Voted For</div>
          </div>

          {users.map((user) => (
            <div key={user.name} className="playerVotingContainer">
              <div className="playerNameVoting">
                {voteCountData[user.name] !== undefined ? (
                  <p
                    className="playerNameText"
                    style={
                      user.name === localPlayer.name
                        ? { color: "yellow" }
                        : { color: "" }
                    }
                  >
                    {user.name} ({voteCountData[user.name]})
                  </p>
                ) : (
                  <p
                    className="playerNameText"
                    style={
                      user.name === localPlayer.name
                        ? { color: "yellow" }
                        : { color: "" }
                    }
                  >
                    {user.name} (0)
                  </p>
                )}
              </div>
              <div className="playerVoteNum">
                {currentVotingData[user.name]}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  } else if (chameleonGuess === false) {
    return (
      <div className="voteTitleContainer">
        {votedPlayerName.length > 1 ? (
          <p className="voteTitleText">
            No vote consensus was reached, the Chameleon (
            {users[chameleonIndex].name}) has won!
          </p>
        ) : (
          <p className="voteTitleText">{msg2Display}</p>
        )}
      </div>
    );
  } else if (chameleonIndex !== null) {
    return (
      <div className="voteTitleContainer">
        {users[chameleonIndex].name !== localPlayer.name ? (
          <p className="voteTitleText ">
            Waiting for {users[chameleonIndex].name} to guess the secret word...
          </p>
        ) : (
          <p className="voteTitleText ">
            Click the word below which you think is the secret word
          </p>
        )}
      </div>
    );
  } else return null;
};

export default VoteResults;
